"use strict";
// @ts-ignore
try {
    self['workbox:cacheable-response:5.1.3'] && _();
}
catch (e) { }
